import React from 'react';
import MaterialCard from '../MaterialCard';
import './FavoritesTab.css';

const FavoritesTab = ({ appData, onToggleFavorite }) => {
  if (!appData) return null;

  // Проверяем, включен ли функционал избранного
  const favEnabled = appData.configs?.fav_on === "true";

  const favoriteMaterials = appData.sections
    .flatMap(section => section.materials.map(material => ({
      ...material,
      uniqueKey: `${section.id}-${material.id}`
    })))
    .filter(material => material.is_favorite);

  return (
    <div className="favorites-tab">
      <div className="section-header">
        <h2>Избранное ({favoriteMaterials.length})</h2>
      </div>
      {favEnabled ? (
        favoriteMaterials.length > 0 ? (
          <div className="materials-grid">
            {favoriteMaterials.map(material => (
              <MaterialCard
                key={material.uniqueKey}
                material={material}
                onToggleFavorite={onToggleFavorite}
                appData={appData}
              />
            ))}
          </div>
        ) : (
          <p className="empty-state">У вас пока нет избранных материалов</p>
        )
      ) : (
        <div className="fav-disabled">
          <p>Скоро будет реализована возможность добавлять материалы в избранное</p>
        </div>
      )}
    </div>
  );
};

export default FavoritesTab; 